import PropTypes from 'prop-types';
import {
  Alert,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
  Box,
} from '@mui/material';
import SensorReadings from './SensorReadings';
import StatusCard from './StatusCard';
import formatBytes from '../../utils/formatBytes';

// ---------------------------------------------------------------------------

export default function OverviewTab({
  serialClient,
  deviceInfo,
  storageInfo,
  passiveFiles,
  captureFiles,
  onTabChange,
  busyOperation,
  latestFirmwareVersion,
  useFahrenheit,
  legacyCounts,
}) {
  const hasUpdate =
    latestFirmwareVersion &&
    deviceInfo?.firmware &&
    latestFirmwareVersion !== deviceInfo.firmware;

  const firmwareSubtitle = hasUpdate
    ? `Update available: v${latestFirmwareVersion}`
    : 'Up to date';

  const totalFiles = (passiveFiles?.length || 0) + (captureFiles?.length || 0);

  return (
    <>
      {hasUpdate && (
        <Alert
          severity="info"
          sx={{ mb: 2 }}
          action={
            <Button color="inherit" size="small" onClick={() => onTabChange(2)}>
              Update Now
            </Button>
          }
        >
          Update available: v{latestFirmwareVersion}
        </Alert>
      )}

      <SensorReadings serialClient={serialClient} busyOperation={busyOperation} useFahrenheit={useFahrenheit} legacyCounts={legacyCounts} />

      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid item xs={12} sm={6}>
          <StatusCard
            title="Firmware"
            value={`v${deviceInfo?.firmware || 'Unknown'}`}
            subtitle={firmwareSubtitle}
            actionLabel="Manage"
            onAction={() => onTabChange(2)}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <StatusCard
            title="Storage"
            value={`${formatBytes(storageInfo?.used || 0)} / ${formatBytes(storageInfo?.total || 0)}`}
            subtitle={`${totalFiles} files`}
            actionLabel="View Files"
            onAction={() => onTabChange(1)}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <StatusCard
            title="Settings"
            value="Configured"
            actionLabel="View Settings"
            onAction={() => onTabChange(3)}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <StatusCard
            title="Rules"
            value="Coming Soon"
            disabled
          />
        </Grid>
      </Grid>
    </>
  );
}

OverviewTab.propTypes = {
  serialClient: PropTypes.object.isRequired,
  deviceInfo: PropTypes.object,
  storageInfo: PropTypes.object,
  passiveFiles: PropTypes.array,
  captureFiles: PropTypes.array,
  onTabChange: PropTypes.func.isRequired,
  busyOperation: PropTypes.string,
  latestFirmwareVersion: PropTypes.string,
};
